import { MutationTree } from 'vuex';
import { TrackingState } from '../../models';
import { SaveProductPageResultIdMutation } from './mutations/save-product-page-result-id.mutation';
import { SetQueryOriginMutation } from './mutations/set-query-origin.mutation';
import { SetResultsEndMutation } from './mutations/set-results-end.mutation';

export const TRACKING_MUTATIONS: MutationTree<TrackingState> = {
  ...new SaveProductPageResultIdMutation().mutations,
  ...new SetQueryOriginMutation().mutations,
  ...new SetResultsEndMutation().mutations
};
